/**
 * AiChatSwitchConfirmDialog — Confirmation dialog for switching AI CLI adapter.
 *
 * Warns that the current chat session will be reset.
 */

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../../../components/ui/alert-dialog';

type AiChatSwitchConfirmDialogProps = {
  open: boolean;
  targetName: string;
  onConfirm: () => void;
  onCancel: () => void;
};

export function AiChatSwitchConfirmDialog({ open, targetName, onConfirm, onCancel }: AiChatSwitchConfirmDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={(o) => { if (!o) onCancel(); }}>
      <AlertDialogContent data-testid="ai-chat-switch-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Switch to {targetName}?</AlertDialogTitle>
        </AlertDialogHeader>
        <AlertDialogDescription>
          This will reset the current chat session. Your conversation history will be lost.
        </AlertDialogDescription>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel} data-testid="ai-chat-switch-cancel">Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} data-testid="ai-chat-switch-confirm">Switch</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
